import { SET_BULK_EXCHANGE_RATE, CLEAR_PARAMS_EXCHANGE_RATE, SET_PARAMS_EXCHANGE_RATE } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    per_page: 10,
    currency_id: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_EXCHANGE_RATE:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_EXCHANGE_RATE:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_EXCHANGE_RATE:
            return initialState;
        default:
            return state;
    }
}
